import PARCEL_STAGE from '@pperform/pp-constants/parcelStage.constants';
import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import PpProgressIndicatorForward from '@pperform/pp-react-components/PpProgressIndicatorForward';
import { checkHasCustomsStage } from '@pperform/pp-utils/parcelOrg';
import { hideCustomsPhaseForEUROPEShipment } from '@pperform/pp-utils/event.utils';
import { usePTPConfigContext } from 'GlobalConfig.context';
import Shipment from 'interfaces/PmParcel';
import { useTranslation } from 'react-i18next';
import { constructForwardProgressIndicatorTheme } from 'utils/progressIndicator.utils';
import { Container } from './ProgressIndicator.styles';

interface ProgressIndicatorProps {
  shipment: Shipment;
}

export const ProgressIndicator = ({
  shipment,
}: ProgressIndicatorProps): JSX.Element => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();
  const {
    trackingDetailsBox: { timelineAlignment },
  } = configs;

  const { isHideCustomsPhase: isHideCustomsPhaseConfig } =
    configs.progressBarBox;
  const { events, issueState } = shipment;

  const hasCustomsStage = shipment && checkHasCustomsStage(shipment);
  const isHideCustomsPhase =
    isHideCustomsPhaseConfig || hideCustomsPhaseForEUROPEShipment(shipment);
  const progressItemThemes = constructForwardProgressIndicatorTheme(configs);

  // Get eventsTypeMasterData array and remove item without stageKey
  const eventsTypeMasterData = events
    ?.map((item) => item?.eventTypeMasterData)
    ?.filter((item) => item?.stageKey);

  // Get stage from newest event
  const stage = eventsTypeMasterData?.[0]?.stageKey || PARCEL_STAGE.pickup;

  return (
    <Container>
      <PpProgressIndicatorForward
        stage={stage}
        events={eventsTypeMasterData}
        progressItemThemes={progressItemThemes}
        hasCustomsStage={hasCustomsStage}
        isHideCustomsPhase={isHideCustomsPhase}
        issueState={issueState}
        translation={t}
        alignEdgeItems={timelineAlignment === CONTENT_ALIGNMENT.LEFT}
      />
    </Container>
  );
};
